function cov_qirkqep1x() {
  var path = "/app/src/components/popup-learn-more-background-header/popup-learn-more-background-header.tsx";
  var hash = "2785814cd8bad2cc71d4043f2d4f064dca6dfe4c";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/popup-learn-more-background-header/popup-learn-more-background-header.tsx",
    statementMap: {
      "0": {
        start: {
          line: 16,
          column: 46
        },
        end: {
          line: 44,
          column: 1
        }
      },
      "1": {
        start: {
          line: 21,
          column: 2
        },
        end: {
          line: 43,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 16,
            column: 46
          },
          end: {
            line: 16,
            column: 47
          }
        },
        loc: {
          start: {
            line: 20,
            column: 13
          },
          end: {
            line: 44,
            column: 1
          }
        },
        line: 20
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 25,
            column: 9
          },
          end: {
            line: 29,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 25,
            column: 9
          },
          end: {
            line: 25,
            column: 18
          }
        }, {
          start: {
            line: 26,
            column: 10
          },
          end: {
            line: 28,
            column: 16
          }
        }],
        line: 25
      }
    },
    s: {
      "0": 0,
      "1": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "2785814cd8bad2cc71d4043f2d4f064dca6dfe4c"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_qirkqep1x = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_qirkqep1x();
import cn from 'classnames';
import React from 'react';
import { Logo } from 'src/components/logo';
import { PopupLearnMoreClose } from 'src/components/popup-learn-more-close';
import { Typography } from 'src/components/v2/typography';
import styles from './styles.css';
cov_qirkqep1x().s[0]++;
export var PopupLearnMoreBackgroundHeader = function PopupLearnMoreBackgroundHeader(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    onClose = _ref.onClose;
  cov_qirkqep1x().f[0]++;
  cov_qirkqep1x().s[1]++;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement(Logo, {
    color: "black on transparent",
    className: styles.logo
  }), (cov_qirkqep1x().b[0][0]++, !!onClose) && (cov_qirkqep1x().b[0][1]++, /*#__PURE__*/React.createElement("div", {
    className: styles.iconContainer
  }, /*#__PURE__*/React.createElement(PopupLearnMoreClose, {
    onClose: onClose
  })))), /*#__PURE__*/React.createElement("div", {
    className: cn(styles.container)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.titleContainer
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "heading1",
    className: styles.title
  }, title), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    className: styles.subtitle
  }, subtitle))));
};